// UI preferences only. Match verification remains the authoritative saved value.
export function seasonTimezoneKey(teamId:string,connectionId:string){
 return `courtcaptain:season-timezone:${[teamId,connectionId].map(encodeURIComponent).join(':')}`;
}
// Preserve a captain's saved timezone when the former Team/Season/connection
// local-storage key becomes Team/connection. A Team represented one Season, so
// the legacy prefix/suffix identify the same preference without a Season ID.
export function readSeasonTimezonePreference(storage:Storage,teamId:string,connectionId:string){
 const key=seasonTimezoneKey(teamId,connectionId);
 const current=storage.getItem(key);
 if(current!==null)return current;
 const prefix=`courtcaptain:season-timezone:${encodeURIComponent(teamId)}:`;
 const suffix=`:${encodeURIComponent(connectionId)}`;
 for(let index=0;index<storage.length;index+=1){
  const legacyKey=storage.key(index);
  if(legacyKey?.startsWith(prefix)&&legacyKey.endsWith(suffix)&&legacyKey!==key){
   const saved=storage.getItem(legacyKey);
   if(saved!==null){storage.setItem(key,saved);return saved;}
  }
 }
 return '';
}
export function matchReviewTimezone(seasonTimezone:string,savedTimezone:string|null|undefined,override:string|null|undefined){
 return override===undefined?savedTimezone||seasonTimezone:override===null?seasonTimezone:override;
}
